import {z} from 'zod';
import {
  DTScheduleNode,
  ScheduleNodeOutputData,
  ScheduleType,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {scheduleCardSchema} from '../../../../../schemas/scheduleCardSchema';
import {TimezoneSource} from 'common/src/modules/timezones/timezones.types';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {UTCAbbreviation} from 'common/src/modules/timezones/timezones.consts';

export function convertScheduleAPICardToAICard(
  scheduleCard: DTScheduleNode,
): z.output<typeof scheduleCardSchema> {
  const candidate: z.input<typeof scheduleCardSchema> = {
    cardId: scheduleCard.id,
    ...scheduleCard,
    type: NodeType.SCHEDULE,
    name: scheduleCard.name ?? '',
    description: scheduleCard.description ?? '',
    outputs: scheduleCard.outputs
      .filter((output) => output.type === OutputType.Regular)
      .map((output: ScheduleNodeOutputData) => ({
        dateRange: output.dateRange
          ? {start: output.dateRange.start.toISO(), end: output.dateRange.end.toISO()}
          : null,
        daysOfWeek: output.daysOfWeek ?? null,
        id: output.id,
        name: output.name ?? '',
        nodeId: output.nodeId ?? NO_NODE_ID,
        type: output.type,
      })),
    scheduleType: scheduleCard.scheduleType ?? ScheduleType.DateRange,
    timezoneSource: scheduleCard.timezoneSource ?? TimezoneSource.Advertiser,
    timeZone: scheduleCard.timeZone ?? UTCAbbreviation,
    randomizeOutputs: scheduleCard.randomizeOutputs ?? false,
  } satisfies z.output<typeof scheduleCardSchema>;

  return candidate;
}
